import queryString from "query-string";
export async function retrieveAccessTokenAM(baseUrl, payload) {
    const formattedPayload = queryString.stringify(payload);
    try {
        const res = await fetch(baseUrl + '/am/oauth2/realms/root/access_token', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formattedPayload
        });
        return await res.json();
    }
    catch (e) {
        console.error('Error while retrieving access token:', e);
        return { message: 'Error while retrieving access token', error: e };
    }
}
// @ts-ignore
export async function getUserAM(baseUrl, accessToken) {
    try {
        return await fetch(`${baseUrl}/am/oauth2/realms/root/userinfo?clientId=vgs_client`, {
            headers: {
                Authorization: 'Bearer ' + accessToken,
            },
        });
    }
    catch (e) {
        console.error("Could not retrieve user ☠");
        return { message: 'Could not retrieve user', error: e };
    }
}
export async function logoutAM(baseUrl, idToken, accessToken) {
    try {
        return await fetch(baseUrl + '/am/oauth2/realms/root/connect/endSession?id_token_hint=' + idToken, {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + accessToken,
            },
        });
    }
    catch (e) {
        console.error("Could not logout from AM");
        return { message: 'Could not logout from AM', error: e };
    }
}
//# sourceMappingURL=AMRequests.js.map